import React from "react";
import clsx from "clsx";

interface DynamicSymbolProps {
  size?: number;
  image?: string;
  imageAlt?: string;
  icon?: React.ReactNode;
  imageHeight?: string | number;
  imageWidth?: string | number;
  className?: string;
  rounded?: boolean;
  bgClass?: string;
}

const DynamicSymbol: React.FC<DynamicSymbolProps> = ({
  size = 50,
  image,
  imageAlt = "symbol",
  icon,
  imageHeight = "50%",
  imageWidth,
  className,
  rounded = false,
  bgClass = "bg-light",
}) => {
  const symbolSize = `${size}px`;

  return (
    <div
      className={clsx("symbol me-5", className)}
      style={{
        width: symbolSize,
        height: symbolSize,
      }}
    >
      <span
        className={clsx(
          "symbol-label d-flex align-items-center justify-content-center",
          bgClass,
          rounded && "rounded-circle"
        )}
        style={{
          width: symbolSize,
          height: symbolSize,
        }}
      >
        {image ? (
          <img
            src={image}
            alt={imageAlt}
            className="align-self-center"
            style={{
              height:
                typeof imageHeight === "number"
                  ? `${imageHeight}px`
                  : imageHeight,
              width:
                typeof imageWidth === "number"
                  ? `${imageWidth}px`
                  : imageWidth,
            }}
          />
        ) : (
          icon ?? <span className="text-muted">?</span>
        )}
      </span>
    </div>
  );
};

export default React.memo(DynamicSymbol);